













import Vue, { PropType } from 'vue';
import { Inverter } from '@/types';

export default Vue.extend({
  props: {
    item: Object as PropType<Inverter>,
  },
});
